import timeComposition from "./composition";
import { composeAPI } from "../Common/api";

export const composedAPI = composeAPI(timeComposition);
